/**
 * Orion Analytics
 * Financial Intelligence Platform
 *
 * Copyright (c) 2026 Santosh Bag / Orion Analytics Ltd.
 * All rights reserved.
 *
 * Software Development by Cosmo Codeworks Ltd
 *
 * Unauthorized copying, modification, distribution,
 * or commercial use is prohibited.
 */

import "../../css/software.css"


export default function OrionEdgePage() {
  return (
    <div className="product-detail-page">
      <section className="product-hero">
        <div>
          <span className="badge live">
            LIVE
          </span>

          <h1>Orion Edge</h1>

          <h3>
            Financial Intelligence.
            Anywhere. Anytime.
          </h3>

          <p>
            Orion Edge is a mobile-first financial toolkit designed
            for traders and investors who need powerful utilities
            on the go.
          </p>

          <div className="hero-actions">
            <a
              href="/downloads/orion-edge.apk"
              className="download-btn"
            >
              Download APK
            </a>
          </div>
        </div>

        <div className="phone-mockup">
          Mobile Preview
        </div>
      </section>

      <section className="stats">
        <div className="stat-card">
          <h2>20+</h2>
          <p>Financial Tools</p>
        </div>

        <div className="stat-card">
          <h2>10+</h2>
          <p>Calculators</p>
        </div>

        <div className="stat-card">
          <h2>100%</h2>
          <p>Mobile Optimized</p>
        </div>
      </section>

      <section className="features-grid">
        <div className="feature-card">
          <h3>Risk Reward</h3>
          <p>Evaluate trades before execution.</p>
        </div>

        <div className="feature-card">
          <h3>Position Sizing</h3>
          <p>Manage risk effectively.</p>
        </div>

        <div className="feature-card">
          <h3>Brokerage Calculator</h3>
          <p>Estimate transaction costs.</p>
        </div>

        <div className="feature-card">
          <h3>Investment Tools</h3>
          <p>Plan long-term wealth creation.</p>
        </div>
      </section>

      <section className="download-section">
        <h2>Ready to Try Orion Edge?</h2>

        <a
          href="/downloads/orion-edge.apk"
          className="download-btn"
        >
          Download APK
        </a>
      </section>
    </div>
  );
}